import gql from 'graphql-tag';

import integrationFragment from '../fragments/integrationFragment';

export const mutationSetCredentialIntegrations = gql`
  mutation setCredentialIntegrations (
    $credentialID: DokkioID!
    $integrations: [IntegrationInput!]
  ) {
    setCredentialIntegrations (
      credentialID: $credentialID
      integrations: $integrations
    ) {
      ...integrationFragment
    }
  }
  ${integrationFragment}
`;
export default mutationSetCredentialIntegrations;
